/**
 * FieldError — the one message under a field that did not pass a check
 * ("title is required", "at least 3 characters"). Replaces alert() in forms:
 * render it right below the input, with the text from t(); it is read out
 * as an alert and stays until the next attempt or the next edit clears it.
 */
import React from 'react';
import styled from '@emotion/styled';
import { AlertCircle } from 'lucide-react';

const Line = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 0 0;
  color: #FFB4B0;
  font-size: 0.86rem;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export default function FieldError({ children, className }) {
  if (!children) return null;
  return (
    <Line role="alert" className={className}>
      <AlertCircle size={15} />
      <span>{children}</span>
    </Line>
  );
}
